module.exports = __webpack_public_path__ + "assets/img/1071587020785_.pic_hd.a1272ac1.jpg";